
import React, { useState } from 'react'
import PlayerDisplay from './PlayerDisplay'
import AddButton from './AddButton'
import * as playerAPI from '../services/player'

const PlayersDisplay = ({ players, setPlayers }) => {

  const [inputName, setInputName] = useState('')

  const rankedPlayers = players.map((player) => {
    return { ...player }
  })
    .sort((a, b) => parseFloat(b.elo) - parseFloat(a.elo))
  rankedPlayers.forEach((player, index) => player.ranking = index + 1)

  const addPlayer = (event) => {
    event.preventDefault()

    if (!inputName) {
      console.log('Empty input name submitted')
      return
    } else if (players.map((player) => player.name).includes(inputName)) {
      console.log('Name already exists')
      return
    }

    const newPlayer = playerAPI.addNew(inputName)
    setPlayers(players.concat(newPlayer))
    setInputName('')
  }

  return (
    <table className="stripedTable players-table">
      <thead>
        <tr>
          <th>Pozycja</th>
          <th>Nazwa drużyny</th>
          <th>Liczba punktów</th>
        </tr>
      </thead>
      <tbody>
        {rankedPlayers.map(player => <PlayerDisplay key={player.id} player={player} />)}
      </tbody>
      <tfoot>
        <tr>
          <td>
            <label
              htmlFor="newPlayerNameInput">
              Nowa drużyna
            </label>
          </td>
          <td>
            <input
              type="text"
              name="newPlayerNameInput"
              id="newPlayerNameInput"
              value={inputName}
              onChange={ ({ target }) => {
                setInputName(target.value)} }
              style={{ 'width': '80%' }}
            />
          </td>
          <td>
            {/* TODO: Disable when input name is empty */}
            <AddButton onClick={ addPlayer } title="Dodaj nową drużynę"/>
          </td>
        </tr>
      </tfoot>
    </table>
  )
}

export default PlayersDisplay
